import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  pickerButton: {
    width: 280,
    alignItems: 'center',
    justifyContent: 'center',
  },
  otherChoisesText: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 21,
    paddingTop: 16,
    alignSelf: 'center',
  },
  containerMobile: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    paddingVertical: 32,
  },
  leftTextTitleMobile: {
    fontWeight: 700,
    fontSize: 16,
    color: brand.main.orange,
  },
  buttonText: {
    color: neutrals.white,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 16,
    textAlign: 'center',
  },
});
